module.exports = __webpack_public_path__ + "assets/img/4-3-en.002f0ae8.png";